import moment from "moment-timezone";

import { api } from "@/APIRequests";
import { eventTypeDisplayNameFactory } from "@/components/Provider/ScheduleAvailability/ActiveScheduleDetails";

export async function getCompletedCalls(urlParams, filter = () => true) {
  const response = await api.provider.fetch_completed_calls({ urlParams });
  const completedCalls = response
    .sort(
      (callA, callB) =>
        moment(callB["timestamp"], "YYYY-MM-DD HH:mm").valueOf() -
        moment(callA["timestamp"], "YYYY-MM-DD HH:mm").valueOf(),
    )
    .filter(filter)
    .map((call) => {
      let display = call.event_type
        ? eventTypeDisplayNameFactory(call.event_type) + " - "
        : "Video Consultation - ";

      display += moment
        .utc(call["timestamp"], "YYYY-MM-DD HH:mm")
        .local()
        .format("YYYY-MM-DD hh:mm A");

      return {
        display: display,
        event_type: call.event_type,
        timestamp: call["timestamp"],
        value: call["callId"],
      };
    });

  completedCalls.unshift({ display: "No Linked Call", value: "no_linked_call" });
  completedCalls.unshift({ display: "Non Billable Encounter", value: "non_billable" });

  return completedCalls;
}
